import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid-premium";
import { BillingAccountType } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";
import { useMemo, useState } from "react";

import { useAllBillingProfilesDataSource } from "@repo/legacy/components/shared/datasources/AllBillingProfilesDataSource";
import ConformationDialog from "@repo/legacy/components/shared/dialogs/Conformation";
import DialogBillingAccount from "@repo/legacy/components/shared/dialogs/DialogBillingAccount";
import List from "@repo/legacy/components/shared/lists/List";

const Billings = () => {
	const { t } = useTranslation();
	const [billing, setBilling] = useState<BillingAccountType | null>(null);
	const [openDialog, setOpenDialog] = useState<boolean>(false);

	const allBillingProfileDataSource = useAllBillingProfilesDataSource();

	const columns: GridColDef[] = useMemo(
		() => [
			{
				field: "name",
				headerName: t("name"),
				flex: 1,
				minWidth: 150,
				renderCell(params: GridCellParams) {
					return params.row.name;
				},
			},
			{
				field: "actions",
				headerName: t("actions"),
				sortable: false,
				width: 150,
				renderCell: (params: GridCellParams) => {
					const [openDeleteConformation, setOpenDeleteConformation] = useState<boolean>(false);

					const handleYes = (id: string) => {
						if (allBillingProfileDataSource.deleteData) allBillingProfileDataSource.deleteData(id);
						setOpenDeleteConformation(false);
					};
					const openDelete = () => {
						setOpenDeleteConformation(true);
					};
					const openEdit = (billing: BillingAccountType | null) => {
						setBilling(billing);
						setOpenDialog(true);
					};

					return (
						<div>
							<Button data-testid="edit-button" onClick={() => openEdit(params.row)}>
								<Edit />
							</Button>
							<Button data-testid="delete-button" onClick={() => openDelete()}>
								<DeleteIcon />
							</Button>
							<ConformationDialog
								text={t("accounting_profiles.deleteConformation")}
								setOpenDeleteConformation={setOpenDeleteConformation}
								openPopup={openDeleteConformation}
								handleYes={() => handleYes(params.id.toString())}
							/>
						</div>
					);
				},
			},
		],

		[t],
	);

	return (
		<>
			<DialogBillingAccount
				refreshData={allBillingProfileDataSource.refresh ?? (() => {})}
				setOpen={setOpenDialog}
				open={openDialog}
				profile={billing}
			/>

			<h3 className="purpleHeader">{t("accounting-profiles")}</h3>
			<List
				columns={columns as GridCellParams<BillingAccountType>[]}
				dataSource={allBillingProfileDataSource}>
				<Button
					className="blueButton right"
					variant="contained"
					data-testid="create-accounting-profile-button"
					onClick={() => {
						setBilling(null);
						setOpenDialog(true);
					}}>
					{t("create-new-accounting-profile")}
				</Button>
			</List>
		</>
	);
};

export default Billings;
